import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const productsJsmAiGovernanceNativeAiCapabilitiesRoute: InvariantJiraRoute = {
	name: 'products-jsm-ai-governance-native-ai-capabilities',
	path: '/jira/settings/products/jira-service-management-ai-governance/native-ai-capabilities',
	exact: true,
};
